"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BenchmarkBase = void 0;
;
;
class BenchmarkBase {
    constructor(logger) {
        this.logger = logger;
    }
    static frameCode(code, name) {
        return `
        <!DOCTYPE html>
        <html>
          <head>
            <title>Benchmark</title>
        
            <script>
              function __startInjectedCode() {
                ${code}
              }

              function start() {
                  try {
                    const retVal = __startInjectedCode();
                    window.parent.postMessage({
                      kind: "benchmarkTestFinished",
                      testId: "${name}",
                      result: retVal
                    }, "*");
                  } catch (err) {
                      window.parent.postMessage({
                        kind: "benchmarkTestFailed",
                        testId: "${name}",
                        error: err
                      }, "*");
                  }
              }
            </script>
        
          </head>
        
          <body onload="start()">
          </body>
        
        </html>        
        `;
    }
    runCode() {
        return __awaiter(this, void 0, void 0, function* () {
            const code = yield this.getCode();
            this.logger.info(`BENCHMARKS runCode, loadedCode length = ${code.length}`);
            const startFunctionCode = this.createStartFunctionCode(code);
            const addFrame = (code) => {
                const frameCode = BenchmarkBase.frameCode(code, this.name);
                const frame = document.createElement("iframe");
                frame.id = "benchmarkFrame";
                frame.style.display = "none";
                frame.srcdoc = frameCode;
                document.body.appendChild(frame);
                return frame;
            };
            const removeFrame = (frame) => {
                document.body.removeChild(frame);
            };
            const logger = this.logger;
            return new Promise((resolve, reject) => {
                addEventListener("message", messageEventHandler, false);
                const frame = addFrame(startFunctionCode);
                function messageEventHandler(event) {
                    if (event.data.kind === "benchmarkTestFinished") {
                        logger.info(`${event.data.testId} executed ${event.data.result} ms.`);
                        removeEventListener("message", messageEventHandler);
                        removeFrame(frame);
                        resolve(event.data.result);
                    }
                    else if (event.data.kind === "benchmarkTestFailed") {
                        logger.error(`${event.data.testId} failed with error: `, event.data.error);
                        removeEventListener("message", messageEventHandler);
                        removeFrame(frame);
                        reject(event.data.error);
                    }
                }
            });
        });
    }
    get name() {
        return this.getBenchmarkName();
    }
    measure() {
        return __awaiter(this, void 0, void 0, function* () {
            this.logger.info(`Start benchmark '${this.name}' measure...`);
            const mean = yield this.runCode();
            const result = 100 * this.getReference() / mean;
            this.logger.info(`BENCHMARKS measure, result = ${result}`);
            return result;
        });
    }
}
exports.BenchmarkBase = BenchmarkBase;
//# sourceMappingURL=BenchmarkBase.js.map